import GlobalComponents from './global-components'

export default {
  install (Vue) {
    Vue.use(GlobalComponents)
  }
}